import { FFEnabledProps } from './FFEnabled.decl';

import { useFeatures } from '@hooks/useFeatures/useFeatures';

export function FFEnabled({ children, featureFlag }: FFEnabledProps): JSX.Element | null {
  const featuresFlags = useFeatures();
  const isEnabled = featureFlag(featuresFlags);
  return isEnabled ? children : null;
}
